<h3 class="color-primary" mat-dialog-title>{{data.title}}</h3>

<div mat-dialog-content>
	<div class="form-group kt-form__group row">
		<div class="col-lg-12">
			{{data.description}}
		</div>
	</div>
</div>
<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{'Close' | translate}}</button>
</div>